import React, { useContext } from "react";

import cx from "classnames";

import { ActionItemsContext } from "~/actionItems/newActionItems/ActionItemsContext";
import type { ActionItem } from "~/actionItems/types";
import { ActionItemIntegrationLinkWidget } from "~/integrations/actionItemIntegration/Widget";
import { AsanaItemsWidget, constructAsanaDataForWidget } from "~/lib/prose/plugins/asanaItems";

import styles from "./ActionItemWidgets.module.css";

interface ActionItemWidgetsProps {
	item: ActionItem;
}

export default function ActionItemWidgets({ item }: ActionItemWidgetsProps) {
	const { id, key, actionItemIntegrationLink, asanablocklink } = item;
	const { inPanel } = useContext(ActionItemsContext);

	const integrationPill = actionItemIntegrationLink ? (
		<span className={cx(styles.data, styles.integrationPill)}>
			<ActionItemIntegrationLinkWidget actionItemLink={actionItemIntegrationLink} />
		</span>
	) : asanablocklink ? (
		<span className={cx(styles.data, styles.integrationPill)}>
			<AsanaItemsWidget asanaItem={constructAsanaDataForWidget(asanablocklink, id, key, "ASANA_COMPLETED")} />
		</span>
	) : (
		<></>
	);

	return <div className={styles.widgets}>{!inPanel && integrationPill}</div>;
}
